import React from 'react';
import styles from './DrMaxReservation.module.scss';
import {
	DrMaxOpeningHourItem,
	useGetPrescriptionQuery,
} from '../../../../graphql/graphql';
import DrMaxPharmacyWorkingHours from '../DrMaxPharmacyWorkingHours/DrMaxPharmacyWorkingHours';
import Loading from '../../../BaseModule/Components/Loading';

interface Props {
	prescriptionId: string;
}

const DrMaxReservation: React.FC<Props> = ({ prescriptionId }) => {
	const { data, isLoading } = useGetPrescriptionQuery({ prescriptionId });
	const openingHours: DrMaxOpeningHourItem[] = data?.prescription
		?.drMaxPickupPlace?.openingHours as DrMaxOpeningHourItem[];

	if (isLoading) {
		return <Loading />;
	}

	if (openingHours) {
		return (
			<div className={styles.wrapper}>
				<DrMaxPharmacyWorkingHours openingHours={openingHours} inReservation />
			</div>
		);
	}

	return <></>;
};

export default DrMaxReservation;
